import * as ents from '@attain-apps/entities'

export interface AgentAssignment {
  id: string
  userName: string
  userId: ents.core.admin.User.Id
  agentId: ents.core.agent.Agent.Id
  agentName: string
  access: ents.core.admin.Access
}

export namespace AgentAssignment {
  export const ACCESS_FLAGS_ATTRIBUTE_ID = 'accessFlags'

  const ACCESS_FLAGS = ents.core.admin.Access.Flag.WithLabel.get()

  /**
   * Formats the stored access bitmask with the same user-facing labels used by
   * assignment modals and Users tabs.
   */
  export function getAccessFlagsLabel(
    assignment: AgentAssignment,
  ): string | undefined {
    const labels = ACCESS_FLAGS.filter(flag =>
      ents.core.admin.Access.allows(assignment.access, flag.value),
    ).map(flag => flag.label)

    return labels.length > 0 ? labels.join(', ') : undefined
  }
}
